import { useTolgee, useTranslate } from "@tolgee/react";
import React from "react";
import { CMS_URL } from "../../../environment.js";
import { useUserData } from "../../auth/useUserData.js";
import { Page } from "../../commons/layout/Page.js";
import { PageContainer } from "../../commons/layout/PageContainer.js";
import { setMxDashboardSearchParams } from "../call-assistant/mxDashboardSearchParams.js";

export const WebShopCms = () => {
  const { t } = useTranslate("SidebarItems");
  const locale = useTolgee(["language"]).getLanguage();
  const viewer = useUserData().currentUser;
  const organisationId = viewer?.organisation.id;
  const userId = viewer?.id;

  // Same identity parameters as the Call Assistant iframe, so the POS
  // dashboard (self-onboarding / self-management) knows org, user and app.
  const iframeSrc = React.useMemo(() => {
    if (!organisationId || !userId) {
      return null;
    }
    const url = new URL(CMS_URL);
    url.search = setMxDashboardSearchParams(url.searchParams, {
      organisationId,
      userId,
      locale,
    }).toString();
    return url;
  }, [locale, organisationId, userId]);

  if (!iframeSrc) {
    return null;
  }

  return (
    <Page>
      <PageContainer $fullHeight $noPadding>
        <iframe
          title={t("Web Shop CMS")}
          style={{
            width: "100%",
            height: "100%",
            border: 0,
            padding: 0,
            margin: 0,
          }}
          src={iframeSrc.toString()}
        ></iframe>
      </PageContainer>
    </Page>
  );
};
